import React from 'react';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { Scrollable } from 'Components/frameworks/scrollable/Scrollable';
import { getMaxItemsWithoutScroll } from './reservedServicesUtils';
import { ReservedServiceBlock } from './ReservedServiceBlock';
type Props = {
  currency: string;
  isWinterResort?: boolean;
  noEditMode?: boolean;
  reservedServicesByAttendee: ReadonlyArray<ReservedServicesByAttendee>;
  scrollBackwardLabel?: string;
  scrollForwardLabel?: string;
};
export const ReservedServicesList = ({
  currency,
  isWinterResort = false,
  noEditMode = false,
  reservedServicesByAttendee = [],
  scrollBackwardLabel,
  scrollForwardLabel,
}: Props) => {
  const responsive = useResponsive();
  const maxItemsWithoutScroll = getMaxItemsWithoutScroll(isWinterResort, responsive);
  return (
    <Scrollable
      backwardLabel={scrollBackwardLabel}
      className="-mx-5"
      forwardLabel={scrollForwardLabel}
      hasNoMouseWheelScroll
      navPosition="center"
    >
      <div className="flex gap-10 ltr:flex-row rtl:flex-row-reverse">
        {reservedServicesByAttendee.map(
          ({
            id,
            isAdult,
            index,
            rentedServices,
            firstName,
            lastName,
            unicodeLastName,
            unicodeFirstName,
          }) => (
            <ReservedServiceBlock
              attendeeId={id}
              className="w-9/10 flex-none md:w-auto md:flex-1"
              currency={currency}
              firstName={firstName}
              index={index}
              isAdult={isAdult}
              key={id}
              lastName={lastName}
              noEditMode={noEditMode}
              rentedServices={rentedServices}
              unicodeFirstName={unicodeFirstName}
              unicodeLastName={unicodeLastName}
            />
          ),
        )}
        {!noEditMode &&
          reservedServicesByAttendee.length < maxItemsWithoutScroll &&
          [...new Array(maxItemsWithoutScroll - reservedServicesByAttendee.length)].map(
            (
              _,
              index, // eslint-disable-next-line react/no-array-index-key
            ) => (
              <div
                key={index}
                className="h-auto w-9/10 flex-none rounded-12 border-1 border-dashed border-lightGrey md:w-auto md:flex-1"
              />
            ),
          )}
      </div>
    </Scrollable>
  );
};
